import { Component, OnInit, signal, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { UploadItem } from '../models/upload-item';
import { PdfType } from '../models/pdf-type';
import { ConstructionSite, NodeItem } from '../../api/models';
import { FileTreeComponent } from '../file-tree/file-tree.component';
import { StateService } from '../../services/state.service';
import { ToolService } from '../../services/tool.service';
import { RouterService } from '../../services/router.service';
import { CameraService } from '../../services/camera.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'lib-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss'],
  standalone: false,
})
export class FilesComponent implements OnInit {
  sub: Subscription;
  conSite: ConstructionSite;
  selectedNodeItem: NodeItem;
  detailsOpened: boolean = true;
  @ViewChild(FileTreeComponent) child!: FileTreeComponent;
  currentFolder = signal<NodeItem>({});
  selectedNodeItems: NodeItem[] = [];
  uploadFiles: UploadItem[] = [];

  constructor(
    public state: StateService,
    public tools: ToolService,
    public routerService: RouterService,
    private cameraService: CameraService,
    private modalService: ModalService
  ) {}

  currentFolderNodeItemChanged(item: NodeItem) {
    this.selectedNodeItem = item;
    this.currentFolder.update((n) => item);
  }

  selectedNodeItemsChanged(items: NodeItem[]) {
    this.selectedNodeItems = items;
  }

  ngOnInit() {
    this.sub = this.state.selectedConSite$.subscribe((x) => (this.conSite = x));
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  async openFile(event: { ids: string[]; index: number }) {
    await this.state.openFile(event.ids, PdfType.Document, event.index);
  }

  goBack() {
    this.child.goBack();
  }

  setUploadItems(files: UploadItem[]) {
    this.uploadFiles = files;
    if (files.length > 0) {
      this.child.topBreadCrumbDisabled = true;
    } else {
      this.child.topBreadCrumbDisabled = false;
    }
  }

  public openFileInput() {
    document.getElementById('file').click();
  }

  public async fileInput(files: FileList) {
    await this.modalService.openUploadModal(null, this.currentFolder(), files);
  }

  public async openCamera() {
    const blobs = await this.cameraService.getPhotos();
    if (blobs.length === 0) {
      return;
    }
    const date = new Date().toLocaleDateString('de-DE', this.tools.options);
    console.log(blobs[0]);
    const items: UploadItem[] = blobs.map((blob, i) => ({
      blob,
      displayName: 'Foto vom ' + date + (blobs.length > 1 ? ` (${i + 1})` : ''),
      fileType: '.' + (blob.type.split('/')[1] || 'jpeg'),
    }));

    await this.modalService.openUploadModal(items, this.currentFolder(), null);
  }
}
